module.exports = __webpack_public_path__ + "static/media/edit.00d3703b.svg";